import {cloneDeep} from 'lodash';
import {getArray, getString, resetObjectValues} from 'Core/helpers/data';
import {DynamicScheduleDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @param {string} campaignId - Campaign ID.
 * @param {string} [defaultTimeZoneId=''] - Default timezone ID to use for the campaign schedule if not specified.
 * @return {DynamicScheduleDataObject}
 */
export const input = (rawData, campaignId, defaultTimeZoneId = '') => {
	let result = cloneDeep(rawData);

	result = new DynamicScheduleDataObject(
		// Copy the campaign ID from the request into the schedule if it does not exist (new schedule will be 
		// created and it needs the campaign ID so we just pass the one from the request).
		(!!getString(result, 'id') ? getString(result, 'campaignId') : campaignId),
		getString(result, 'id'),
		getString(result, 'messageDefinitionGenerationTime'),
		(getString(result, 'timeZoneId') || defaultTimeZoneId),
		getString(result, 'scheduleIntervalType'),
		getArray(result, 'scheduleDays').map(i => getString(i)),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {DynamicScheduleDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep({
		campaignId: inputData.campaignId,
		id: inputData.id,
		messageDefinitionGenerationTime: inputData.time,
		timeZoneId: inputData.timeZoneId,
		scheduleIntervalType: inputData.intervalType,
		scheduleDays: inputData.days,
	});

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}